import { Analytics } from "./analytics";

export function InitializeSearchHeader() {
    let searchInput = document.querySelector('[data-search-input]') as HTMLInputElement;
    let searchSubmit = document.querySelector('[data-search-submit]') as HTMLInputElement;

    if (searchInput && searchSubmit) {
        let analytics = new Analytics();

        // Register search click
        searchSubmit.addEventListener('click', (e) => {
            // Push analytics
            analytics.PushSearchTerm(searchInput.value);
        });
    }
}

export function InitializeSearchPageSubmit() {
    let searchPageInput = document.querySelector('[data-search-page-input]') as HTMLInputElement;
    let searchForm = document.querySelector('[data-search-form]') as HTMLFormElement;

    if (searchPageInput && searchForm) {
        let analytics = new Analytics();

        // Register search click
        searchForm.addEventListener('submit', (e) => {
            // Push analytics
            analytics.PushSearchTerm(searchPageInput.value);
        });
    }
}








// WEBPACK FOOTER //
// ./Static/javascript/modules/search.ts